import { AlertModal, useOpenModal } from '@modusign/design-system';
import { useVerifyInvitation } from '@modusign/openapi-client-user';
import { useHistory, useParams } from 'react-router';
import { useMount } from 'react-use';

import GlobalLoadingSpinner from '@app/components/Loading/GlobalLoadingSpinner';

import { InvitationState } from './types';

const statuses: readonly InvitationState[] = [
  'ONGOING',
  'ACCEPTED',
  'CANCELED',
  'REJECTED',
] as const;

function InvitationVerificationPage() {
  const history = useHistory();
  const { invitationId } = useParams<{ invitationId: string }>();

  const openModal = useOpenModal();
  const verifyInvitation = useVerifyInvitation({
    request: {
      credentials: false,
    },
  });

  useMount(() => {
    verifyInvitation.mutate(
      {
        invitationId,
      },
      {
        onSuccess: ({ email, status, signedUp }) => {
          if (signedUp) {
            const [isOngoing, isAccepted, isCanceled, isRejected] = statuses.map(
              (v) => v === status
            );

            if (isOngoing) {
              openModal(
                ({ isOpen, onClose }) => (
                  <AlertModal
                    isOpen={isOpen}
                    maxWidth="xs"
                    title="초대 수락 안내"
                    variant="basic"
                    onClose={onClose}
                  >
                    {'초대를 받으셨군요!\n초대받은 이메일로 로그인해 주세요.'}
                  </AlertModal>
                ),
                { keepOnUnmount: true }
              );
            }
            if (isAccepted) {
              openModal(
                ({ isOpen, onClose }) => (
                  <AlertModal
                    isOpen={isOpen}
                    maxWidth="xs"
                    title="초대 수락 안내"
                    variant="basic"
                    onClose={onClose}
                  >
                    {'이미 초대를 수락했어요.\n로그인 후 공용 워크스페이스를 이용해 보세요.'}
                  </AlertModal>
                ),
                { keepOnUnmount: true }
              );
            }
            if (isCanceled) {
              openModal(
                ({ isOpen, onClose }) => (
                  <AlertModal
                    isOpen={isOpen}
                    maxWidth="xs"
                    title="초대 수락 안내"
                    variant="warning"
                    onClose={onClose}
                  >
                    {'이미 취소된 초대입니다.\n워크스페이스 관리자에게 초대를 요청해 주세요.'}
                  </AlertModal>
                ),
                { keepOnUnmount: true }
              );
            }
            if (isRejected) {
              openModal(
                ({ isOpen, onClose }) => (
                  <AlertModal
                    isOpen={isOpen}
                    maxWidth="xs"
                    title="초대 수락 안내"
                    variant="warning"
                    onClose={onClose}
                  >
                    {'이전에 초대를 거절했습니다.\n워크스페이스 관리자에게 초대를 요청해 주세요.'}
                  </AlertModal>
                ),
                { keepOnUnmount: true }
              );
            }

            history.push(`/authentication/signin?email=${encodeURIComponent(email)}`);
          } else {
            openModal(
              ({ isOpen, onClose }) => (
                <AlertModal
                  isOpen={isOpen}
                  maxWidth="xs"
                  title="초대 수락 안내"
                  variant="basic"
                  onClose={onClose}
                >
                  {'초대장을 받으셨군요!\n초대받은 이메일로 회원가입해 주세요.'}
                </AlertModal>
              ),
              { keepOnUnmount: true }
            );
            history.push(`/authentication/signup?email=${encodeURIComponent(email)}`);
          }
        },
        onError: () => {
          openModal(
            ({ isOpen, onClose }) => (
              <AlertModal
                isOpen={isOpen}
                maxWidth="xs"
                title="초대 수락 안내"
                variant="warning"
                onClose={onClose}
              >
                {
                  '초대 정보를 불러오지 못했습니다.\n현재 창을 닫고, 이메일의 초대 수락 버튼을 다시 눌러 주세요.'
                }
              </AlertModal>
            ),
            { keepOnUnmount: true }
          );
          history.push(`/authentication/signin`);
        },
      }
    );
  });

  return <GlobalLoadingSpinner />;
}

export default InvitationVerificationPage;
